






























































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store/store";
import TextInput from "@/components/TextInput.vue";
import LineChart from "@/components/Charts/LineChart.vue";
import { mapGetters } from "vuex";
import { pinboardService } from "@/services/pinboard.service";
import { settingService } from "@/services/setting.service";
import { jobService } from "@/services/job.service";
import { userService } from "@/services/user.service";
import { categoryService } from "@/services/category.service";
import { statisticService } from "@/services/statistic.service";
import { Setting } from "@/models/setting.model";
import { companyService } from "../../services/company.service";
import Utils from "@/common/utils";
import { ChartData } from "@/models/chart.model";
import { Resources } from "@/shared/resources";

export interface JobStat {
    value?: number;
    property?: string;
}

@Component({
    computed: mapGetters({
        companyName: "app/companyName"
    }),
    components: {
        TextInput,
        LineChart
    }
})
export default class Admin extends Vue {
    // tslint:disable

    jobs: string[] = [];
    pinboards: string[] = [];
    users: string[] = [];

    // pinboardCount: number = 0;
    // jobCount: number = 0;
    // userCount: number = 0;
    // categoryCount: number = 0;

    doneText: string = "Klar!";
    muchNowText: string = "Mycket att göra nu, hjälp!";
    nothingToDoText: string = "Inget att göra!";
    companySetting: Setting = { id: 0 };
    companySettingChanged: boolean = false;
    chartDataCollection: ChartData[] = [];
    dateInterval: any = Resources.dateInterval;

    dashboardSummary: any = [];
    fromDate: Date = new Date();
    toDate: Date = new Date();

    async created() {
        // this.pinboardCount = await pinboardService.getCount();
        // this.jobCount = await jobService.getCount();
        // this.userCount = await userService.getCount();
        // this.categoryCount = await categoryService.getCount();
        let classStat = await statisticService.getStatisticsInformationOnClass(
            "JobEvent"
        );

        this.dashboardSummary = await statisticService.getDashboardSummary(
            store.getters["app/companyId"]
        );
        this.companySetting = await settingService.getByCompanyId(
            store.getters["app/companyId"]
        );
        this.companySettingChanged = false;

        this.fromDate = new Date(classStat.minDate);
        this.toDate = new Date(classStat.maxDate);

        await this.initChartStats(this.fromDate, this.toDate);
    }

    async initChartStats(
        fromDate: Date = this.fromDate,
        toDate: Date = this.toDate
    ) {
        this.chartDataCollection = [];
        let done = await statisticService.getAssignedJobsChartDataStatistics({
            companyId: this.$store.getters["app/companyId"],
            fromDate: fromDate,
            toDate: toDate,
            jobEventStatus: 2,
            dateInterval: 2
        });

        let assigned = await statisticService.getAssignedJobsChartDataStatistics({
            companyId: this.$store.getters["app/companyId"],
            fromDate: fromDate,
            toDate: toDate,
            jobEventStatus: 1,
            dateInterval: 2
        });

        let moved = await statisticService.getAssignedJobsChartDataStatistics({
            companyId: this.$store.getters["app/companyId"],
            fromDate: fromDate,
            toDate: toDate,
            jobEventStatus: 3,
            dateInterval: 2
        });

        this.chartDataCollection.push({
            data: Utils.mapToChartData(done),
            title: "Gjorda"
        } as ChartData);
        this.chartDataCollection.push({
            data: Utils.mapToChartData(assigned),
            title: "Tilldelade"
        } as ChartData);
        this.chartDataCollection.push({
            data: Utils.mapToChartData(moved),
            title: "Flyttade"
        } as ChartData);

        // @ts-ignore
        this.$refs.lineChart.render(this.chartDataCollection);
        this.chartDataCollection = [];
    }

    file: any;
    newImage: boolean = false;
    errors: string[] = [];

    // REGION image upload
    async processFile(event: any) {
        this.file = event.target.files[0];
        if (
            !this.file.name.toLowerCase().includes(".png") &&
            !this.file.name.toLowerCase().includes(".gif") &&
            !this.file.name.toLowerCase().includes(".jpg") &&
            !this.file.name.toLowerCase().includes(".gif")
        ) {
            this.errors.push("Endast jpg, gif, png tillåtna");
        }

        this.newImage = true;
        // this.userImageSourceFromBase64 = URL.createObjectURL(this.file);
        if (this.$store.getters["app/companyImage"]) {
            await this.updateImage();
        } else {
            await this.createImage();
        }

        await this.$store.dispatch(
            "app/getCompanyInfoFromKey",
            store.getters["app/companyId"]
        );
    }

    async createImage() {
        let formData = new FormData();
        formData.append("file", this.file);
        await companyService.createImage(
            formData,
            store.getters["app/companyId"]
        );
        this.newImage = false;
    }

    async updateImage() {
        let formData = new FormData();
        formData.append("file", this.file);
        await companyService.updateImage(
            formData,
            store.getters["app/companyId"]
        );
        this.newImage = false;
    }

    pushToPage(page: string) {
        this.$router.push(`/admin/${page}`);
    }

    @Watch("companySetting", { immediate: false, deep: true })
    settingsChanged() {
        this.companySettingChanged = true;
    }

    async updateSettings() {
        this.companySettingChanged = false;
        this.companySetting.companyId = store.getters["app/companyId"];
        settingService.update(this.companySetting).then(result => {
            this.$notify({
                group: "message",
                title: "Succe!",
                text: "Inställningar sparade",
                duration: 5000,
                type: "success"
            });
            this.$store.dispatch("app/setSetting", result);
        });
    }
}
